import { createContext, useContext, type ReactNode } from 'react';
import { useEventStream, type StreamStatus, type StreamEvent } from './useEventStream';
import { useAuth } from './auth';

interface EventStreamContextValue {
  status: StreamStatus;
  lastEvent: StreamEvent | null;
  subscribe: (eventType: string, callback: (event: StreamEvent) => void) => () => void;
}

const EventStreamCtx = createContext<EventStreamContextValue | null>(null);

export function EventStreamProvider({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const stream = useEventStream({ enabled: !loading && !!user });

  return (
    <EventStreamCtx.Provider value={stream}>
      {children}
    </EventStreamCtx.Provider>
  );
}

export function useEventStreamContext(): EventStreamContextValue {
  const ctx = useContext(EventStreamCtx);
  if (!ctx) {
    throw new Error('useEventStreamContext must be used within EventStreamProvider');
  }
  return ctx;
}
